import React from 'react';
import './AppLogo.css';

export const APP_LOGO_SRC = `${process.env.PUBLIC_URL}/assets/indus-logo-blue.png`;

/** Same image logo as LoginPage (`indus-logo-blue.png`). */
export default function AppLogo({ variant = 'default', className = '', alt = 'Indus Informatics' }) {
  return (
    <img
      className={`app-logo app-logo--${variant} ${className}`.trim()}
      src={APP_LOGO_SRC}
      alt={alt}
    />
  );
}
